'use client';

import { useEffect } from 'react';
import { useRouter } from '@/i18n/routing';

// Re-runs the server render on an interval while the page is visible, so
// server-rendered data (market quotes) keeps ticking without user action.
// Renders nothing.
export default function AutoRefresh({ seconds = 30 }: { seconds?: number }) {
  const router = useRouter();
  useEffect(() => {
    const id = setInterval(() => {
      if (document.visibilityState === 'visible') router.refresh();
    }, seconds * 1000);
    return () => clearInterval(id);
  }, [router, seconds]);
  return null;
}
